import { render, staticRenderFns } from "./primaryButton.vue?vue&type=template&id=79a7832e"
import script from "./primaryButton.vue?vue&type=script&lang=js"
export * from "./primaryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/vercel/path0/components/ui/spinner.vue').default,Img: require('/vercel/path0/components/ui/img.vue').default})
